import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4127292"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/mall/svgo-alert.png",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" ご注意ください ")
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r1" }, " THE CKB輸入代行サービスはD2CとB2Bの、二つのシステムに分かれています。 ", -1))
const _hoisted_4 = { class: "r2" }
const _hoisted_5 = { class: "r2-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/mall/2c介绍.png",
  alt: ""
}, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/mall/2b介绍.png",
  alt: ""
}, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r2-5" }, [
  /*#__PURE__*/_createTextVNode(" ·B2BとD2Cの手数料は異なる場合があります。詳細は"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.theckb.com/price/plan/",
    target: "_blank",
    style: {"color":"#0586FE"}
  }, "料金プラン"),
  /*#__PURE__*/_createTextVNode("をご参照ください。 ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r3" }, [
  /*#__PURE__*/_createElementVNode("div", null, "新規店舗作成について："),
  /*#__PURE__*/_createElementVNode("div", null, "※スタンダードプラン以上の方は新しい店舗（子アカウント）を作成できます"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/mall/2c-choice.png",
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "r4" }

import { useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import { isJA, useUser } from '@/store'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visible = ref(false)

const systemSource = ref(1)

onMounted(async () => {
  if (!isJA()) return
  const user = useUser()
  const isEcUser = !user.ext?.includes('choice')
  if (!isEcUser) return
  systemSource.value = user.systemSource
  const [get, set] = useUserConfig(ENUM_CONFIG_CODE.NOT_FIRST_USE_CART)
  const NOT_FIRST_USE_CART = await get()
  if (NOT_FIRST_USE_CART) return
  visible.value = true
  set(1)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: 720,
    top: "5vh",
    "modal-class": " bc-intro"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              (systemSource.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('ご利用中のシステム')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              (systemSource.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)('ご利用中のシステム')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_10
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})